import cloneDeep from 'lodash/cloneDeep';
import each from 'lodash/each';
import get from 'lodash/get';
import set from 'lodash/set';

import SubUser from './model';
import { SubUsersCollection } from './collection';

export const state = {
  subUsersCollection: new SubUsersCollection(),
  paymentInfo: {
    ach_details: {},
    bank_check_details: {},
    wire_details: {},
    payoneer_accounts: [],
    pingpong_accounts: [],
  },
  paymentInfoSubmitted: {
    ACH: false,
    BANK: false,
    WIRE: false,
    PAYPAL: false,
  },
  originalPaymentInfo: null, // confirm popup tracker
  currentPayoneerAccountId: null,
  currentPingpongAccountId: null,
  emailConfig: {},
  paymentModals: {
    bank: false,
    ach: false,
    wire: false,
    paypal: false,
    payoneer: false,
    pingpong: false,
  },
};

export const mutations = {
  setSubUsers(state, subUsers) {
    each(subUsers, user => {
      user.editing = false;
      user.password = '';
      user.view_payouts = get(user, 'permissions.payouts.view');
      user.request_payouts = get(user, 'permissions.payouts.request');
      user.access_domains = get(user, 'permissions.domains.access');
    });

    state.subUsersCollection.users = subUsers;
  },

  setPaymentInfo(state, info) {
    state.paymentInfo = info;

    if (!state.paymentInfo.wire_details.account_type) state.paymentInfo.wire_details.account_type = 'PERSONAL';
    if (!state.paymentInfo.ach_details.type) state.paymentInfo.ach_details.type = 'CHECKING';
    if (!state.paymentInfo.ach_details.type2) state.paymentInfo.ach_details.type2 = 'PERSONAL';

    state.originalPaymentInfo = cloneDeep(info);
  },

  setPaymentInfoByType(state, { type, info }) {
    switch (type) {
      case 'PAYPAL':
        state.paymentInfo.paypal_email = info.paypal_email;
        state.originalPaymentInfo.paypal_email = cloneDeep(info.paypal_email);
        break;
      case 'ACH':
        if (!state.paymentInfo.ach_details.type) state.paymentInfo.ach_details.type = 'CHECKING';
        if (!state.paymentInfo.ach_details.type2) state.paymentInfo.ach_details.type2 = 'PERSONAL';
        state.paymentInfo.ach_details = info.ach_details;
        state.originalPaymentInfo.ach_details = cloneDeep(info.ach_details);
        break;
      case 'BANK_CHECK':
        state.paymentInfo.bank_check_details = info.bank_check_details;
        state.originalPaymentInfo.bank_check_details = cloneDeep(info.bank_check_details);
        break;
      case 'PAYONEER':
        state.paymentInfo.payoneer_accounts = info.payoneer_accounts;
        state.originalPaymentInfo.payoneer_accounts = cloneDeep(info.payoneer_accounts);
        break;
      case 'PINGPONG':
        state.paymentInfo.pingpong_accounts = info.pingpong_accounts;
        state.originalPaymentInfo.pingpong_accounts = cloneDeep(info.pingpong_accounts);
      case 'WIRE':
        if (!state.paymentInfo.wire_details.account_type) state.paymentInfo.wire_details.account_type = 'PERSONAL';
        state.paymentInfo.wire_details = info.wire_details;
        state.originalPaymentInfo.wire_details = cloneDeep(info.wire_details);
        break;
    }
  },

  updatePaymentInfo(state, { prop, value }) {
    set(state.paymentInfo, prop, value);
  },

  setCurrentPayoneerAccountId(state, id) {
    state.currentPayoneerAccountId = id;
  },

  setEmailConfig(state, config) {
    state.emailConfig = config;
  },

  updateEmailConfig(state, { property, value }) {
    state.emailConfig[property] = value;
  },

  togglePaymentModal(state, { modal, value }) {
    state.paymentModals[modal] = value;
  },

  addSubUser(state) {
    state.subUsersCollection.users = [...state.subUsersCollection.users, new SubUser()];
  },

  removeNewSubUser(state) {
    state.subUsersCollection.users.pop();
  },

  clearUserBeingEdited(state) {
    each(state.subUsersCollection.users, user => {
      user.editing = false;
    });
  },
};